<template>
    <div class="bg-white rounded-lg shadow-md p-5 lg:p-8 m-2 lg:mx-4">
        <div class="flex justify-between items-center mb-4">
            <div class="font-semibold text-gray-600 text-xl mb-4">
                Logística
            </div>
            <Button
                variant="dismissive"
                v-tooltip.top="'Descargar etiqueta'"
                @click="downloadLabel"
            >
                <Icon size="20">
                    <Bookmark />
                </Icon>
            </Button>
        </div>
        <div class="flex flex-col space-y-6">
            <div class="w-full flex">
                <div class="w-1/2">
                    <div class="text-gray-500 text-[12px] uppercase">Fecha</div>
                    <span class="text-lg text-gray-800">
                        {{ formatDate(envio.created_at) }}
                    </span>
                </div>

                <div class="w-1/2 flex items-center justify-start space-x-4">
                    <div>
                        <div class="text-gray-500 text-[12px] uppercase">
                            Nro. Orden
                        </div>
                        <span class="text-lg text-gray-800">
                            {{ envio.orden_id === null ? "-" : envio.orden_id }}
                        </span>
                    </div>
                    <Icon
                        v-if="envio.listo_para_recolectar"
                        size="20"
                        v-tooltip.top="'Listo para recolectar'"
                    >
                        <BoxCheckmark24Filled class="text-gray-600" />
                    </Icon>
                </div>
            </div>

            <div
                class="w-full flex flex-col md:flex-row space-y-6 md:space-y-0"
            >
                <div class="md:w-1/3">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Sucursal
                    </div>
                    <span class="text-lg text-gray-800">
                        {{ sucursal.nombre }}
                    </span>
                </div>

                <div class="md:w-2/3">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Seguimiento
                    </div>
                    <TrackingColumn
                        :shipment="envio"
                        :proveedores="proveedores"
                    />
                </div>
            </div>

            <div class="flex w-full">
                <div class="w-1/3">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Peso Facturado
                    </div>
                    <span class="text-lg text-gray-800"
                        >{{ envio.peso_facturado }}kg</span
                    >
                </div>
                <div class="w-1/3">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Peso real
                    </div>
                    <span class="text-lg text-gray-800"
                        >{{ envio.peso_real }}kg</span
                    >
                </div>
                <div class="w-1/3">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Peso volumetrico
                    </div>
                    <span class="text-lg text-gray-800">
                        {{ envio.peso_volumetrico }}kg
                    </span>
                </div>
            </div>

            <template
                v-if="
                    $page.props.user.tipo === 'super_admin' ||
                    $page.props.user.tipo === 'global_admin'
                "
            >
                <div class="flex w-full">
                    <div class="w-1/2">
                        <div class="text-gray-500 text-[12px] uppercase">
                            Precio proveedor
                        </div>
                        <span class="text-lg text-gray-800">
                            {{ envio.precio_proveedor }} ARS
                        </span>
                    </div>

                    <div class="w-1/2">
                        <div class="text-gray-500 text-[12px] uppercase">
                            Precio facturado
                        </div>
                        <span class="text-lg text-gray-800">
                            {{ envio.precio_factura }} ARS
                        </span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="w-full">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Precio de envio
                    </div>
                    <span class="text-lg text-gray-800">
                        {{ envio.precio_factura }} ARS
                    </span>
                </div>
            </template>

            <div>
                <div class="text-gray-500 text-[12px] uppercase">
                    Ult. estado
                </div>
                <span class="text-lg text-gray-800">{{ envio.estado }} </span>
            </div>

            <div class="flex w-100">
                <div class="w-1/2">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Tipo de envio
                    </div>
                    <span class="text-lg text-gray-800">{{ envio.tipo }} </span>
                </div>

                <div class="w-1/2">
                    <div class="text-gray-500 text-[12px] uppercase">
                        Fragil
                    </div>
                    <span class="text-lg text-gray-800"
                        >{{ envio.fragil === "0" ? "No" : "Si" }}
                    </span>
                </div>
            </div>

            <div>
                <div class="text-gray-500 text-[12px] uppercase">
                    Observación
                </div>
                <span class="text-lg text-gray-800"
                    >{{ envio.observacion === null ? "-" : envio.observacion }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "@/shared/Button.vue";
import TrackingColumn from "../TrackingColumn.vue";
import { Icon } from "@vicons/utils";
import { Bookmark } from "@vicons/fa";
import { BoxCheckmark24Filled } from "@vicons/fluent";
import formatDate from "@/helpers/formatDate";
import axios from "axios";

export default {
    name: "LogisticsPanel",
    components: {
        Button,
        TrackingColumn,
        Icon,
        Bookmark,
        BoxCheckmark24Filled,
    },
    props: {
        envio: Object,
        proveedores: Object,
        sucursal: Object,
    },
    methods: {
        formatDate,
        downloadLabel() {
            axios
                .get("/envios/etiqueta/" + this.envio.seguimiento, {
                    "Content-Disposition": "attachment",
                })
                .then((res) => {
                    let downloadLabel = document.createElement("a");
                    downloadLabel.href =
                        "data:application/octet-stream;base64," + res.data.etiquetas;
                    downloadLabel.download = `shipro_${this.envio.seguimiento}.pdf`;
                    downloadLabel.click();
                })
                .catch((err) => console.error(err));
        },
    },
};
</script>
